module.exports = __webpack_public_path__ + "img/about_logo_28.35b61bcf.png";